EventedPromise = require 'utils/evented-promise'

DS.Model.reopen
  modelSerializer: (->
    @store.serializerFor(@get('constructor'))
  ).property().volatile()

  modelAdapter: (->
    @store.adapterFor(@get('constructor'))
  ).property().volatile()

  mediator: Em.inject.service('mediator')

  modelName: (->
    @constructor.toString().split('.')[1].underscore()
  ).property()

  # ---
  # Для nonREST действий иногда полезно бывает пометить
  # изменение модели
  # ---
  notifyRecordChange: ->
    @get('mediator').trigger('modelChanged', 'n/a', @get('modelName'), @)

  ###
  # Для реализации non-REST методов
  ###
  nonRESTAction: (method, action, data=null, settings={}) ->
    type     = @get('constructor')
    typeName = @get('constructor.typeKey')

    adapter = @get('modelAdapter')
    baseURL = adapter.buildURL(typeName, @get('id'))

    URL = "#{baseURL}/#{action}"

    ajaxProps =
      url:     URL
      headers: adapter.get('headers')
      type:    method

    if data and method != 'GET'
      ajaxProps.contentType = 'application/json; charset=utf-8';
      ajaxProps.data = JSON.stringify(data)
    else
      ajaxProps.data = data

    new Em.RSVP.Promise (resolve, reject) =>
      Em.$.ajax(Em.merge(ajaxProps, settings)).then(resolve, reject)

  ###
  # Для загрузки файлов
  ###
  fileUpload: (action, file, settings={}) ->
    type     = @get('constructor')
    typeName = @get('constructor.typeKey')

    adapter = @get('modelAdapter')
    baseURL = adapter.buildURL(typeName, @get('id'))

    URL = "#{baseURL}/#{action}"

    data = new FormData()

    fileKey = settings.fileKey || 'file'

    if !Em.isEmpty(file)
      if Em.isArray(file)
        file.forEach (f) =>
          data.append "#{fileKey}[]", f
      else
        data.append(fileKey, file)

    formDataParams = settings.formDataParams || {}
    for k, v of formDataParams
      data.append(k, v)

    promise = null

    ajaxProps = Em.merge({
      xhr: ->
        xhr = new window.XMLHttpRequest()
        xhr.upload.addEventListener 'progress', (evt) ->
          if evt.lengthComputable
            percent = evt.loaded / evt.total
            percent = parseInt(percent * 100)
            promise?.trigger?('progress', percent)
        , false
        xhr
      url:         URL
      data:        data
      headers:     adapter.get('headers')
      type:        'PUT'
      cache:       false
      contentType: false
      processData: false
    }, settings)

    underlayedPromise = new Em.RSVP.Promise (resolve, reject) =>
      Em.$.ajax(ajaxProps).then(resolve, reject)

    promise = EventedPromise.create(promise: underlayedPromise)
